const StringToNumberDirective = function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ngModel: ng.INgModelController) {
            ngModel.$parsers.push(function (value) {
                return '' + value;
            });
            ngModel.$formatters.push(function (value) {
                return parseFloat(value);
            });
        }
    };
};

export { StringToNumberDirective };